import { HomeAPIList, OsmAPIList } from '@/api'

const api = new HomeAPIList();

export default {
  getMessageList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getMessageList(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getRenewalList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getRenewalList(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBirthdayList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBirthdayList(param, (json) => {
        json.status === 200 ? resolve(json.data) : reject(json.message);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBulletinList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBulletinList(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBulletinDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBulletinDetail(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getDashboardCharts({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getDashboardCharts(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getCustomerPolicyList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCustomerPolicyList(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },



  getCaseTrendChart({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCaseTrendChart(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getFycTrendChart({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getFycTrendChart(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },

  getCommTrendChart({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCommTrendChart(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      });
    });
  },


}



// WEBPACK FOOTER //
// ./src/Homepage/store/actions.js